import App from './App';
import ReactDOM  from 'react-dom';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
         <App /> , 
    document.getElementById('root'));

